import React from "react";
import {
  SettingsHeader,
  SettingsSubHeader,
} from "pages/AdminSettings/Authentication/AuthPage";

const UpgradeBanner = () => {
  return (
    <main>
      <SettingsHeader className="mt-1">自定义品牌</SettingsHeader>
      <SettingsSubHeader className="w-7/12 mt-1">
        为您的平台自定义 LOGO 和品牌色
      </SettingsSubHeader>
    </main>
  );
};

export default UpgradeBanner;
